import { render, staticRenderFns } from "./IconValue.vue?vue&type=template&id=f2248c08&"
import script from "./IconValue.vue?vue&type=script&lang=js&"
export * from "./IconValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports